import React, { useState } from 'react';
import HeaderNonSrp from '../header/headerNonSrp';
import SubHeader from '../header/subHeader';
import GInput from '../common/input/ginput';
import { baseCss } from "../common/css";
import { renderImg } from '../common/icons/img';
import Footer from '../footer/footer';
import AccountLoader from '../manageAccount/accountLoader';
import { apiUrl } from '../common/constants';
import { GetRequest, getparamsString } from '../common/helper';
import AlertFail from '../common/alertFail';
import Alert from '../common/alert';
const GuestEdit = () => {
   const [pnr, setPnr] = useState("");
   const [pwd, setPwd] = useState("");
   const [mobile, setMobile] = useState("");
   const [loader, setLoader] = useState(false);
   const [isCancelled, setCancelled] = useState(false);
   const [bookingData, setBookingData] = useState(false);
   const [errMsg, setErrorMsg] = useState("");

   const valiDateDtl = () => {
      if (!pnr) {
         setErrorMsg("Please Enter Pnr");
         return false;
      }
      if (!mobile || mobile.length < 8) {
         setErrorMsg("Please Enter Phone");
         return false;
      }
      if (!pwd) {
         setErrorMsg("Please Enter Txn Password");
         return false;
      }
      if (pwd && pwd.length < 6) {
         setErrorMsg("Txn Password must be at least 6 characters long.");
         return false;
      }
      return true;
   };

   const checkTxnPwd = () => {
      setLoader(true);
      const url = `${apiUrl.validateTxnPwd}?pnr=${pnr}&txnPwd=${pwd}&mobile=${mobile}`;
      GetRequest(url)
         .then((response) => {
            setLoader(false);
            if (response.Success) {
               getPnrDetail();
            } else {
               setErrorMsg('Please Enter the valid details')
               setLoader(false);
            }
         })
         .catch(() => { setLoader(false) });
   }

   const getPnrDetail = () => {
      if (valiDateDtl()) {
         setLoader(true);
         if (pnr) {
            setLoader(true);
            const data = {
               PNR: pnr,
               mobile: mobile
            };
            const url = apiUrl.bookingInfo + "?" + getparamsString(data);
            GetRequest(url)
               .then((res) => {
                  console.log(res)
                  if (res.Status && !res.Error) {
                     let bookingInfo = res.BookingInfo.APIGetBookingDetailsResult[0];
                     setBookingData(
                        bookingInfo
                     );
                     if (bookingInfo.BookingStatus === 'B') {
                        window.location.href = `/guest-edit-confirm?pnr=${bookingInfo.BookingRefNo}&mobile=${mobile}`
                     }
                     if (bookingInfo.BookingStatus === 'C') {
                        setCancelled(true);
                     }
                     setLoader(false);
                  } else {
                     if (res.Error) {
                        setErrorMsg(res.Error)
                     }
                  }
               })
               .catch((err) => {
                  setLoader(false);
                  console.log(err);
               });
         }
      }
   }

   return (
      <div className='guest--cancel--wrapper'>
         <HeaderNonSrp />
         <SubHeader />
         {loader && <AccountLoader />}
         <div className="guest--cancel--inputs">
            <div style=
               {{
                  color: '#202020',
                  fontWeight: '600',
                  fontSize: '16px',
                  lineHeight: '24px',
                  letterSpacing: '0.01rem'
               }}>Edit Bus Booking</div>
            <div
               style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#444',
                  fontSize: '14px',
                  fontWeight: '500',
                  letterSpacing: '0.02rem',
                  lineHeight: '20px',
                  paddingTop: '10px'
               }}
            >
               <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>{renderImg('exicon')}</div>
               <div>You are guest & not logged in</div>
            </div>
            <GInput
               type="text"
               value={pnr}
               onChange={(e) => setPnr(e)}
               errMsg="Enter Pnr Number"
               label="PNR Number"
               key={"pnr"}
               icon={renderImg('cancel_pnr')}
               // validation="pnr"
               iconError={renderImg("pnr_error")}
            />

            <GInput
               type="text"
               value={pwd}
               onChange={(e) => setPwd(e)}
               errMsg="Enter Transaction Password"
               label="Transaction Password"
               key={"password"}
               validation={"txn_password"}
               icon={renderImg("txn_pwd")}
               max={6}
               iconError={renderImg("lock-icon-error")}
            />
            <GInput
               type="tel"
               value={mobile}
               onChange={(e) => setMobile(e)}
               validation="mobile2"
               errMsg="Enter Valid Mobile Number"
               label="Mobile Number"
               key={"mobileno"}
               icon={renderImg("phone-icon")}
               iconError={renderImg("phone-icon-error")}
            />
            <div
               className="btn payee"
               style={baseCss.secondaryBackground}
               onClick={checkTxnPwd}
            >
               SEARCH
            </div>
            {isCancelled &&

               <AlertFail
                  msg={
                     <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                     >
                        <div className="icon">
                           {renderImg('fail_icon')}
                        </div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                           This ticket is not Editable. you have already cancelled it.
                        </div>
                     </div>
                  }

               />}
            {errMsg && (
               <Alert
                  msg={errMsg}
                  error={true}
                  close={() => setErrorMsg("")
                  }
               />
            )}
         </div>
         <Footer />
      </div>
   )
}
export default GuestEdit;